'use client';

import { c as _c } from "react/compiler-runtime";
import PreRegisterForm from '@/app/(public)/(auth)/register/components/form';
import InView from '@/components/ui/in-view';
import { cn } from '@/lib/utils';
import { LEARN_MORE_PRE_REGISTER_TEXTS } from '../../shared/constants/paragraphs';
import { LEARN_MORE_PRE_REGISTER_SECTION_ID } from '../../shared/constants/section-ids';
export function LearnMorePreRegisterSection() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0,
      filter: "blur(4px)"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      hidden: t0,
      visible: {
        opacity: 1,
        filter: "blur(0px)",
        transition: {
          delay: 0.1
        }
      }
    };
    t2 = {
      margin: "0px 0px -100px 0px",
      once: true
    };
    t3 = {
      duration: 0.3,
      ease: "easeInOut"
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <InView variants={t1} viewOptions={t2} transition={t3} className="flex w-full lg:pt-4"><div className="flex w-full max-w-xl mx-auto flex-col gap-6"><h1 className=" lg:text-left text-center font-playflair text-4xl font-normal leading-snug text-foreground sm:text-6xl ">{LEARN_MORE_PRE_REGISTER_TEXTS.title}</h1><div className="lg:text-left text-center flex flex-col gap-4 font-dm_sans text-base leading-relaxed text-foreground sm:text-lg">{LEARN_MORE_PRE_REGISTER_TEXTS.paragraphs}</div></div></InView>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      opacity: 0,
      filter: "blur(4px)"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <section id={LEARN_MORE_PRE_REGISTER_SECTION_ID} className="relative flex w-full scroll-mt-40 flex-col items-center gap-12 bg-[#E5E5E5] px-6 py-16 sm:px-12 lg:gap-0 lg:flex-row xl:px-20">{t4}<InView variants={{
        hidden: t5,
        visible: {
          opacity: 1,
          filter: "blur(0px)",
          transition: {
            delay: 0.1
          }
        }
      }} viewOptions={{
        margin: "0px 0px -100px 0px",
        once: true
      }} transition={{
        duration: 0.3,
        ease: "easeInOut"
      }} className={cn("flex w-full justify-center lg:justify-end")}><PreRegisterForm variant="learn-more" /></InView></section>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}